module.exports = __webpack_public_path__ + "arrow_icon.f1a7753e.png";